import { FormattedMessage } from 'dibs-react-intl';

export const recentlyViewedTitle = (
    <FormattedMessage id="RecentlyViewedItemsCarousel.title" defaultMessage="Recently Viewed" />
);
